<script lang="ts">
export default {
  name: "LeftAnalysis",
};
</script>
<script setup lang="ts">
import { DEVICE_NAME } from '@/types/device'
import { waylineFilePage } from "@/api/analysisApi/index"
import { onMounted } from 'vue'
import { store } from '@/store'
import { getDroneStatistic, getFlyStatistic } from "@/api/analysisApi/index"

const organizationData: any = computed(() => store.informationListStore.informationStore().organizationData)

const searchForm:any = reactive({
  name: ""
})
const waylineList: any = ref([])

const getWaylineFilePage = () => {
  searchForm.provinceCode = import.meta.env.VITE_APP_AREACODE,
  searchForm.cityCode = organizationData.value.cityCode,
  searchForm.areaCode = organizationData.value.areaCode,
  searchForm.orgId = organizationData.value.provinceCode,
  waylineFilePage(searchForm).then(res => {
    waylineList.value = res.list
  })
}

function formatFlyTime(time: string) {
  if (time != null && time !== '') {
    const arr = time.split(":");
    if (arr[0] === "00") {
      if (arr[1] === "00") {
        return arr[2] + "秒";
      } else {
        return arr[1] + "分" + arr[2] + "秒";
      }
    } else {
      return arr[0] + "时" + arr[1] + "分" + arr[2] + "秒";
    }
  }
}


const regionNum = reactive({
  droneNum: 0,
  pilotNum: 0
})

const DroneStatistic = () => {
  const params: any = {}
    params.provinceCode = import.meta.env.VITE_APP_AREACODE,
    params.cityCode = organizationData.value.cityCode,
    params.areaCode = organizationData.value.areaCode,
    params.orgId = organizationData.value.provinceCode,
    getDroneStatistic(params).then((res) => {
      Object.assign(regionNum, res)
    })
}

const flyData = reactive({
  flightDistance: 0,
  flightHour: 0,
  flightMinute: 0,
  flightTimeStr: 0,
  flightSecond: 0,
})

const FlyStatistic = () => {
  const params: any = {}
    params.provinceCode = import.meta.env.VITE_APP_AREACODE,
    params.cityCode = organizationData.value.cityCode,
    params.areaCode = organizationData.value.areaCode,
    params.orgId = organizationData.value.provinceCode,
    getFlyStatistic(params).then((res) => {
      Object.assign(flyData, res)
    })
}

watch(() => store.informationListStore.informationStore().organizationData, (newVal, oldVal) => {
  DroneStatistic()
  FlyStatistic()
  getWaylineFilePage()
}, {
  immediate: true,
  deep:true
})

onMounted(() => {
})
</script>

<template>
  <div class="left-analysis">
    <div class="big-title">综合分析</div>
    <div class="number-box">
      <div class="small-title mt10">区域内数量</div>
      <div class="block-box" style="margin-top: 0.935rem;">
        <p>
          <img src="@/assets/images/uav-img.png" alt="">
        </p>
        <p class="uav">无人机：</p>
        <p style="color:#00B9FF">{{ regionNum.droneNum }}</p>
        <p>个</p>
      </div>
      <div class="block-box">
        <p>
          <img src="@/assets/images/airport-img.png" alt="">
        </p>
        <p class="airport">机场：</p>
        <p style="color:#00FF97">{{ regionNum.pilotNum }}</p>
        <p>个</p>
      </div>
    </div>
    <div class="air-line-box">
      <div class="small-title">航线列表</div>
      <div class="block-date">
        <el-input v-model="searchForm.name" style="width: 12.5vw" placeholder="请输入航线名称" />
        <el-button type="primary" class="submitBtn" @click="getWaylineFilePage()">查询</el-button>
      </div>
      <div class="line-list-box">
        <div class="list-box" v-for="(item, index) in waylineList">
          <p style="color: #FFCC00;" :title="item.name">航线名称：{{ item.name }}</p>
          <p>无人机名称/编号：{{ DEVICE_NAME[item.drone_model_key] }}</p>
          <p style="color: #00FFE5;">飞行时长：{{ formatFlyTime(item.predict_fly_time) }}</p>
        </div>
      </div>
    </div>
    <div class="flight-data-box">
      <div class="small-title">飞行数据</div>
      <div class="flight-list-box">
        <div class="flight-list">
          <p>
            <img src="@/assets/images/cishu.png" alt="">
          </p>
          <p>飞行次数:</p>
          <p>
            <span style="font-size: 1.5rem;color: #1590fc;font-weight: 800;font-style: italic;">{{ flyData.numberOfFlights }}</span>
            <span style="font-size: 0.75rem;color: #1590fc;">次</span>
          </p>
        </div>
        <div class="flight-list">
          <p>
            <img src="@/assets/images/shijian.png" alt="">
          </p>
          <p>飞行时间:</p>
          <p>
            <span style="font-size: 1.5rem;color: #00ffae;font-weight: 800;font-style: italic;">{{ flyData.flightHour }}</span>
            <span style="font-size: 0.75rem;color: #00ffae;">时</span>
            <span style="font-size: 1.5rem;color: #00ffae;font-weight: 800;font-style: italic;">{{ flyData.flightMinute }}</span>
            <span style="font-size: 0.75rem;color: #00ffae;">分</span>
            <span
              style="font-size: 1.5rem;color: #00ffae;font-weight: 800;font-style: italic;">{{ flyData.flightSecond }}</span>
            <span style="font-size: 0.75rem;color: #00ffae;">秒</span>
          </p>
        </div>
        <div class="flight-list">
          <p>
            <img src="@/assets/images/juli.png" alt="">
          </p>
          <p>飞行距离:</p>
          <p>
            <span
              style="font-size: 1.5rem;color: #f5be1c;font-weight: 800;font-style: italic;">{{ flyData.flightDistance }}</span>
            <span style="font-size: 0.75rem;color: #f5be1c;">米</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.left-analysis {
  position: absolute;
  top: 7.5rem;
  left: 0;
  width: 21.1vw;
  height: 88vh;
  background: url("@/assets/images/left-monitor-bj.png") no-repeat center;
  background-size: 100% 100%;

  .number-box {
    height: 22vh;

    .block-box {
      display: flex;
      width: 15.6vw;
      height: 8vh;
      border-radius: 15px;
      margin: 0 auto;

      justify-content: space-around;
      align-items: center;

      p {
        color: #fff;
      }

      p:nth-child(1) {
        width: 4.2vw;
        height: 6.8vh;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .uav {
        background: url("@/assets/images/word-bj.png") no-repeat center;
      }

      .airport {
        background: url("@/assets/images/word-bj2.png") no-repeat center;
      }

      p:nth-child(2) {
        width: 4.8vw;
        height: 2.7vh;
        font-family: Segoe UI, Segoe UI;
        font-weight: normal;
        font-size: 1.125rem;
        color: #F6F9FE;
        line-height: 2.7vh;
        font-style: normal;
        text-indent: .3125rem;
        background-size: 100% 100%;
      }

      p:nth-child(3) {
        font-family: Segoe UI, Segoe UI;
        font-weight: 600;
        font-size: 2.25rem;
        text-align: left;
        font-style: italic;
      }

      p:nth-child(4) {
        margin-top: .625rem;
      }
    }
  }

  .air-line-box {
    height: 34vh;

    .block-date {
      margin-top: 1.25rem;
      margin-left: 2rem;

      .submitBtn {
        height: 2.8vh;
        margin-left: 0.25rem;
      }

      :deep(.el-input__wrapper) {
        background-color: rgba(0, 0, 0, 0.3);
        height: 2.8vh;

        .el-input__inner {
          height: 2.8vh;
          color: #fff;
        }
      }
    }

    .line-list-box {
      width: 20vw;
      height: 24.5vh;
      margin: .625rem auto;
      overflow-y: auto;

      .list-box {
        width: 90%;
        height: 11vh;
        background-color: rgba(0, 0, 0, 0.32);
        margin: 0.6rem auto;
        border-radius: 10px;
        border: 2px solid #bcc5cb;
        display: flex;
        flex-direction: column;
        justify-content: center;
        cursor: pointer;

        p {
          position: relative;
          font-size: 1rem;
          color: #fff;
          margin: 3px 1.25rem;
          white-space: nowrap;
          /* 确保文本在一行内显示 */
          overflow: hidden;
          /* 隐藏溢出的内容 */
          text-overflow: ellipsis;
          /* 使用省略号表示文本溢出 */
          line-height: normal;

          span {
            position: absolute;
            right: 0;
          }
        }
      }
    }
  }

  .flight-data-box {
    height: 24vh;

    .flight-list-box {
      width: 90%;
      height: 17vh;
      margin: 1.25rem auto;
      padding: .6875rem 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      background: rgba(0, 0, 0, 0.5);

      .flight-list {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #fff;

        p {
          font-size: 1rem;
        }

        p:nth-child(1) {
          width: 2.7vw;
          height: 4vh;
          margin-left: 2.5rem;

          img {
            width: 100%;
            height: 100%;
          }
        }

        p:nth-child(3) {
          width: 8.8vw;
          text-align: center;
        }
      }
    }
  }
}
</style>
